import Block from './Block'

export default Block



// WEBPACK FOOTER //
// ./src/components/Block/index.js